import axios from '../../../axiosConfig';

const BASE = '/utilities/notes';

export const notesService = {
  async list(q) {
    const params = q ? { q } : undefined;
    const { data } = await axios.get(BASE, { params });
    return data?.notes || [];
  },

  async create({ title = null, body = '' } = {}) {
    const { data } = await axios.post(BASE, { title, body });
    return data?.note;
  },

  async get(id) {
    const { data } = await axios.get(`${BASE}/${id}`);
    return data?.note;
  },

  async update(id, patch) {
    const { data } = await axios.patch(`${BASE}/${id}`, patch);
    return data?.note;
  },

  async remove(id) {
    await axios.delete(`${BASE}/${id}`);
  }
};
